import { sum, avg } from './shared/math'
import { buildSharedMonths } from './shared/periods'

export const buildRawMonthlySeries = ({ planoData, realizadoData, estoquePecasData, estoqueReaisData }) => {
  const plano = planoData || [];
  const realizado = realizadoData || [];
  const estoquePecas = estoquePecasData || [];
  const estoqueReais = estoqueReaisData || [];

  const { monthKeys } = buildSharedMonths([plano, realizado, estoquePecas, estoqueReais]);

  return monthKeys.map((key) => {
    const [year, month] = key.split('-').map(Number);

    const realEntries = realizado.filter(d => d.year === year && d.month === month);
    const planoEntries = plano.filter(d => d.year === year && d.month === month);
    const estoqueEntries = estoquePecas.filter(d => d.year === year && d.month === month);

    const grossRevenue = sum('grossRevenue', realEntries) ?? sum('grossRevenue', planoEntries);
    const unitsSold = sum('unitsSold', realEntries) ?? sum('unitsSold', planoEntries);
    const originalPrice = avg('originalPrice', realEntries) ?? avg('originalPrice', planoEntries);
    const unitCost = avg('unitCost', realEntries) ?? avg('unitCost', planoEntries);
    const salePrice = avg('salePrice', realEntries) ?? avg('salePrice', planoEntries);
    const markdownPercent = avg('markdownPercent', realEntries) ?? avg('markdownPercent', planoEntries);
    const initialMarkup = avg('initialMarkup', realEntries) ?? avg('initialMarkup', planoEntries);
    const finalMarkup = avg('finalMarkup', realEntries) ?? avg('finalMarkup', planoEntries);
    const grossProfit = sum('grossProfit', realEntries) ?? sum('grossProfit', planoEntries);

    return {
      year, month,
      grossRevenue, unitsSold, originalPrice, unitCost,
      salePrice, markdownPercent, initialMarkup, finalMarkup, grossProfit,
      initialInventoryUnits: sum('initialInventoryUnits', estoqueEntries),
      endingInventoryUnits: sum('endingInventoryUnits', estoqueEntries),
      inboundInventoryUnits: sum('inboundInventoryUnits', estoqueEntries),
      openToBuyUnits: sum('openToBuyUnits', estoqueEntries),
      actualInventoryCoverage: avg('actualInventoryCoverage', estoqueEntries),
      plannedInventoryCoverage: avg('plannedInventoryCoverage', estoqueEntries),
      plannedUnitsSold: sum('unitsSold', planoEntries),
      idealInventoryUnits: null,
    };
  });
};